import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import AccommodationPage from "./pages/AccommodationPage";
import Login from "./pages/admin/Login";
import ForgotPassword from "./pages/admin/ForgotPassword";
import ResetPassword from "./pages/admin/ResetPassword";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Photos from "./pages/admin/Photos";
import Rooms from "./pages/admin/Rooms";
import Content from "./pages/admin/Content";
import Account from "./pages/admin/Account";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/acomodacoes/:slug" element={<AccommodationPage />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/esqueci-senha" element={<ForgotPassword />} />
            <Route path="/admin/redefinir-senha" element={<ResetPassword />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="fotos" element={<Photos />} />
              <Route path="acomodacoes" element={<Rooms />} />
              <Route path="conteudo" element={<Content />} />
              <Route path="conta" element={<Account />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
